<template>
  <OrderForm :config="config" />
</template>

<script>
import OrderForm from "../../components/OrderForm/OrderForm.vue";

export default {
  name: "app",
  components: {
    OrderForm
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
